class VideoSlider {
  constructor($el) {
    this.$el = $el;
    this.$slider = $el.find('[data-video-slider="slider"]');
    this.$videos = $el.find('[data-video-slider="video"]');

    console.log(this.$videos);

    this.init();
  }

  init = () => {
    import("slick-carousel").then(() => {
      this.$slider.slick({
        infinite: true,
        speed: 1000,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
      });

      this.$videos[0].play();

      this.$slider.on(
        "beforeChange",
        (event, slick, currentSlide, nextSlide) => {
          this.$videos[currentSlide].pause();
          this.$videos[nextSlide].play();
        }
      );
    });
  };
}

export default VideoSlider;
